export default "__VITE_ASSET__BbLHSDbW__"